import { Link, useParams, useRouter } from "@tanstack/react-router";
import "./../../styles/embeddedHtmlStyles.scss";
import type { SubscriptionCourseProduct, CourseKey } from "../../api/api.types";
import { MultimediaCard } from "../Workshop/MultimediaCard";
// import { CoursesCertificats } from "../Workshop/CoursesCertificats";
import { useSuspenseQuery } from "@tanstack/react-query";
import {
	// getProfileOptions,
	getSubscriptionCourseOptions,
} from "@/api/queryOptions";
import { CourseTitleCard } from "./CourseTitleCard";
import { InfoDialogIcon } from "@/components/icons/infoDialog";
import { kursyAll, type Kurs } from "@/kursy/general";
// import { TrainingFile } from "@/components/shared/TrainingFile";

function resolveCourseProduct(
	products: Array<SubscriptionCourseProduct>,
	kurs: Kurs | undefined
): SubscriptionCourseProduct | undefined {
	if (!products.length) return undefined;
	if (kurs?.productId != null) {
		return products.find((p) => p.id === kurs.productId) ?? undefined;
	}
	return products[0];
}

export const CourseStudy = (): JSX.Element => {
	const { courseKey } = useParams({
		from: "/(app)/_app/course/$courseKey",
	});
	const router = useRouter();

	const basicCurrentKurs = kursyAll.find((kurs) => kurs.slug === courseKey);

	// Use the same query that was used in CoursesRachunkowoscList
	const { data: subscriptionData } = useSuspenseQuery(
		getSubscriptionCourseOptions(courseKey as CourseKey)
	);
	// const { data: profile } = useSuspenseQuery(getProfileOptions);
	// const trainingMaterials = profile?.resources.find(
	// 	(resource) => resource.id === subscriptionData?.products?.[0]?.id
	// );

	if (!subscriptionData || !subscriptionData.has_access) {
		return (
			<div className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] flex items-center justify-center">
				<div className="text-center text-rose-500">
					Nie masz dostępu do tego kursu
				</div>
			</div>
		);
	}

	const products = (subscriptionData.products ?? []) as Array<SubscriptionCourseProduct>;
	const product = resolveCourseProduct(products, basicCurrentKurs);

	if (!product) {
		return (
			<div className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] flex items-center justify-center">
				<div className="text-center text-gray-500">
					Nie udało się załadować danych kursu
				</div>
			</div>
		);
	}

	return (
		<main className="py-3 pb-5 px-safe-offset-3 min-h-[calc(100vh-176px)] overflow-x-hidden max-w-[890px] mx-auto">
			<div className="flex text-fontDarkGray pb-4">
				<button
					className="whitespace-nowrap flex-shrink-0"
					onClick={() => {
						router.history.back();
					}}
				>
					Kursy
				</button>
				<span className="px-4">&#8226;</span>
				<span className="truncate min-w-0">{product.name}</span>
			</div>

			{/* Course Cover Card - simplified version since we don't have all the same data */}
			{basicCurrentKurs && (
				<>
					<CourseTitleCard kurs={basicCurrentKurs} />
					<div className="m-8">
						<p className="text-sm text-gray-500">
							{basicCurrentKurs?.description}
						</p>
					</div>
				</>
			)}

			<div className="flex justify-start items-center m-8 ml-[14px]">
				<InfoDialogIcon className="mr-[15px] flex-shrink-0" />
				<span className="text-sm font-bold min-w-0">
					Materiały dodatkowe do pobrania w zakładce{" "}
					<Link
						to="/my-academy"
						search={{ mainCategory: "FILES" }}
						className="text-blue-500 underline"
					>
						Moja Akademia
					</Link>
				</span>
			</div>

			{/* Course Classes/Lessons */}
			{product.courseClasses
				.sort((a, b) => a.order - b.order)
				.map((element) => {
					return (
						<MultimediaCard
							key={element.id}
							courseClassData={element}
							productData={{
								productName: product.name,
								productType: "course",
								authors: [],
								productSlug: product.slug,
								productId: product.id.toString(),
							}}
							// slug={product.slug}
							// workshopId={product.id.toString()}
						/>
					);
				})}

			{/* {trainingMaterials?.media.map((element) => (
				<TrainingFile key={element.id} file={element} />
			))} */}

			{/* Course Certificate Section - if user owns the product */}
			{/* {subscriptionData.has_access && (
				<CoursesCertificats courseName={product.name} courseId={product.id} />
			)} */}
		</main>
	);
};
